import React from 'react';

const HomeSkeleton = () => {
  return (
    <div className="min-h-screen">
      {/* Hero Skeleton */}
      <div className="animate-pulse bg-gray-200 h-[600px] w-full"></div>

      {/* Services Section */}
      <div className="container mx-auto px-4 py-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div className="animate-pulse bg-gray-200 h-[200px]"></div>
          <div className="animate-pulse bg-gray-200 h-[200px]"></div>
          <div className="animate-pulse bg-gray-200 h-[200px]"></div>
        </div>
      </div>

      {/* Stats Skeleton */}
      <div className="container mx-auto px-4 py-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
          <div className="animate-pulse bg-gray-200 h-[150px]"></div>
          <div className="animate-pulse bg-gray-200 h-[150px]"></div>
          <div className="animate-pulse bg-gray-200 h-[150px]"></div>
          <div className="animate-pulse bg-gray-200 h-[150px]"></div>
        </div>
      </div>

      {/* Reviews Skeleton */}
      <div className="container mx-auto px-4 py-8">
        <div className="animate-pulse bg-gray-200 h-[300px]"></div>
      </div>

      {/* Gallery Skeleton */}
      <div className="container mx-auto px-4 py-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
          <div className="animate-pulse bg-gray-200 h-[250px]"></div>
          <div className="animate-pulse bg-gray-200 h-[250px]"></div>
          <div className="animate-pulse bg-gray-200 h-[250px]"></div>
          <div className="animate-pulse bg-gray-200 h-[250px]"></div>
        </div>
      </div>
    </div>
  );
};

export default HomeSkeleton;